<template>
  <Dialog
    width="608px"
    titleAlign="center"
    :title="null"
    :subTitle="null"
    :hideCloseBtn="createRenderType == 'pc' ? false : true"
    :showBottomCloseBtn="createRenderType == 'pc' ? false : true"
    :visible="visible"
    @close="closeDialog"
    background="linear-gradient(130deg, #5325A2 0%, #7D6FD6 47%, #501269 100%)"
    :backgroundImage="false"
    :customClass="`${createRenderType}-subscriptio-dialog subscriptio-dialog`"
  >
    <div>
      <div class="tip-text">
        {{ $$t("credit.your_subscription_is_currently", '',{ stripe: userDataStore.channel == "stripe" ? "Stripe" : "Paypal" }) }}
      </div>
      <div class="btn-group">
        <div class="btn btn-close" @click="closeDialog">{{ $$t("create.close") }}</div>
        <div class="btn btn-show" @click="goContral">{{ $$t("credit.view_stripe_account",'',{ stripe: userDataStore.channel == "stripe" ? "Stripe" : "Paypal" }) }}</div>
      </div>
    </div>
  </Dialog>
</template>

<script setup>
import { defineProps, defineEmits, getCurrentInstance, watch, onMounted } from "vue";
import { useRouter } from "vue-router";
import { storeToRefs } from "pinia";


import VocalGroup from "../../create/subscribe-dialog/vocal.vue";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
import { reportGeneral, manageSubscription } from "@/api/api/apiCredit.js";
import useDialogStore from "@/store/dialogStore.js";
import globalConfig from "@/config/config.js";
import useUserDataStore from "@/store/userDataStore";

const userDataStore = useUserDataStore();

const dialogStore = useDialogStore();
const globalProperties = getCurrentInstance()?.appContext.config.globalProperties;
const { $$t, $$language } = globalProperties?.$i18n ?? {};
const createLayoutStore = useCreateLayoutStore();
const { createRenderType } = storeToRefs(createLayoutStore);
const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  isFirst: {
    type: Boolean,
    default: true,
  },
});
const emits = defineEmits(["updata:visible", "updata: isFirst"]);
const router = useRouter();
const link = ref("");

const closeDialog = () => {
  emits("update:visible", false);
};

const goContral = () => {
  window.open(link.value);
};

const init = () => {
  if (userDataStore.channel == "stripe") {
    manageSubscription({
      channel: "stripe",
    }).then((res) => {
      if (res.code == 200) {
        link.value = res?.data?.url;
      }
    });
  } else {
    link.value = globalConfig.paypalConsoleUrl;
  }
};

onMounted(() => {
  init();
});
</script>

<style lang="scss" scoped>
.subscriptio-dialog {
  position: relative;
  .tip-text {
    color: #fff;
    text-align: center;
    font-size: 22px;
    padding: 20px 60px 0;
  }
  .btn-group {
    display: flex;
    margin: 30px;
    gap: 30px;
    .btn {
      flex: 1; /* 每个按钮平分父容器宽度 */
      padding: 10px 0; /* 添加一些内边距 */
      font-size: 16px; /* 设置字体大小 */
      text-align: center;
      border-radius: 20px;
      &.btn-close {
        background-color: gray;
        color: #fff;
      }
      &.btn-show {
        background: linear-gradient(91deg, #4fdeff -40%, #d9f8ff 52%, #e675ff 132%);
        color: #000;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .subscriptio-dialog {
  }
}
</style>
